const formations = [
  {
    label: "Management IT & Entrepreunariat",
    value: "Management IT & Entrepreunariat"
  },
  {
    label: "Transformation Digitale & Management",
    value: "Transformation Digitale & Management"
  }
]

export default formations
